module.exports = __webpack_public_path__ + "img/icon_cart_bottom.2c65e96a.jpg";